/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICittaPaymentAfterpayTabContentProps {
    isBusy?: boolean;
    afterpayAvailable?: boolean;
    afterpayImgSrc: string;
    instalmentAmount: string;
    // tslint:disable-next-line:no-any
    processAfterpayOrder (e:any):Promise<void>;
}

const CittaPaymentAfterpayContentTab = ({
    isBusy,
    afterpayAvailable,
    afterpayImgSrc,
    instalmentAmount,
    processAfterpayOrder
}:ICittaPaymentAfterpayTabContentProps) => {
    const callToActionProps = {
      className: 'btn btn-primary checkout-place-order__btn-place-order',
      title: isBusy ? 'Please wait ' : 'Proceed to Afterpay',
      onClick: processAfterpayOrder,
      glyph: isBusy ? 'spinner' : '',
      disabled: isBusy
    };
    return (
      <div className='ap citta-afterpay-payment'>
        {afterpayAvailable && (
          <div className='payment-afterpay-container'>
            <div className='block-title'>
              <img
                src={afterpayImgSrc}
                alt='AfterPay'
              />
            </div>
            <h5>Shop now. Enjoy now. Pay later.</h5>
            <p>Four interest-free payments of <strong>${instalmentAmount}, every 2 weeks</strong></p>
           
            <div className='afterpay-terms'>
              <p>
                <strong>
                  You will be taken to the Afterpay website to complete your order.
                </strong>
              </p>
              <p>
                <a href='https://www.afterpay.com/en-NZ/terms-of-service' target='_blank' className='afterpay-tc'>
                  Learn More
                </a>
              </p>
              <button {...callToActionProps}>
                {isBusy ? 'Please wait ' : 'Proceed to Afterpay'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
};

export default React.memo(CittaPaymentAfterpayContentTab);